module.exports = __webpack_public_path__ + "static/img/big-screen.5789eeaf.png";